module.exports = __webpack_public_path__ + "static/media/bandeira_vermelha_p2.2a8acca4.png";